export default __webpack_public_path__ + "static/media/standard_01.37aa848d.png";